var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 117,
    y: 0,
    width: 35,
    height: 35,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 0h56.946c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 64 0 60.418 0 56s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H77v17a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H80.192 119a2 2 0 0 0-2 2v31a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM77 15.489c-3.426-1.14-5.862-4.063-5.862-7.489 0-3.781 2.968-6.95 6.958-7.785A2 2 0 0 0 77 2v13.489ZM206.946 48c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 35.582 216 40s-4.054 8-9.054 8ZM79 40a2 2 0 0 0-2 2v31a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2V42a2 2 0 0 0-2-2H79Zm40 0a2 2 0 0 0-2 2v31a2 2 0 0 0 2 2h31a2 2 0 0 0 2-2V42a2 2 0 0 0-2-2h-31Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 78.25,
    y: 1.25,
    width: 32.5,
    height: 32.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#6A6666",
    mask: "url(#b)",
    strokeWidth: 5,
    strokeDasharray: 5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 78.25,
    y: 41.25,
    width: 32.5,
    height: 32.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 118.25,
    y: 41.25,
    width: 32.5,
    height: 32.5,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.44a729f1cbf9344de10ae31eef2b8707.svg";
export { ForwardRef as ReactComponent };